import React, { useEffect, useState } from "react";
import model_mining_logo from "../assets/model_mining_logo.jpg";
import model_mining_logo_2 from "../assets/LogoCompleto.png";
import model_mining_background from "../assets/background_imagen_login.jpeg";
import { authLogin } from "../services/authLogin";
import { useLocation, useNavigate } from "react-router-dom";
import { useCheckAuthToken } from "../hooks/useCheckAuthToken";
import { CustomLoader } from "../components/CustomLoader";
import { transformSelectFormat } from "../utils/transformFormatSelect";
import Select from "react-select";
import {
  joinApplication,
} from "../services/initializeApplication";

const Select_App_Simplefms = () => {
  const [selectedApp, setSelectedApp] = useState("");
  const [userId, setUserId] = useState(null);
  const [applicationList, setApplicationList] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuth } = useCheckAuthToken();

  useEffect(() => {
    (async () => {
      if (location.state === undefined) return;

      // Si no se envió data válida, redirigir
      if (
        !location.state ||
        !location.state.data ||
        !location.state.data.apps_by_user
      ) {
        localStorage.removeItem("token_jwt");
        navigate("/");
        return;
      }
      setUserId(location.state.data.user_info.user_id);
      var result_app_list = transformSelectFormat(
        location.state.data.apps_by_user,
        "application_id",
        "application_name"
      );
      //console.log(result_app_list);
      if ((result_app_list.status = 200)) {
        setApplicationList(result_app_list.data);
      }
    })();
  }, [location]);

  //console.log(isAuth);

  const handleJoinApp = async () => {
    await joinApplication(userId, selectedApp, applicationList, navigate);
  };

  return (
    <div class="justify-center px-6 py-12 bg-slate-200 h-screen">
      {isAuth == null ? (
        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-6">
          {" "}
          <CustomLoader />{" "}
        </div>
      ) : (
        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm bg-white p-6">
          <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              class="mx-auto h-25 w-auto "
              src={model_mining_logo_2}
              alt="Model Mining"
            />
            <h2 class="mt-10 text-center font-bold">Select application</h2>
          </div>
          <div>
            <div class="mt-2 mb-4">
              <Select
                defaultValue={selectedApp}
                onChange={setSelectedApp}
                options={applicationList}
              />
            </div>
          </div>

          <div>
            <button
              class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={handleJoinApp}
            >
              Join
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Select_App_Simplefms;
